import uniqBy from 'lodash/uniqBy';

import { Clientize, PayoutEvent, PayoutEventMap, PayoutTransactionsViewWithFincoData } from 'types';
export enum BatchComponent {
  queued = 'queued',
  paid = 'paid',
}

/**
 * A row of the transactions list at either level: project rows and organization (payee) rows come
 * from the same view and the same endpoint. project, projectExternalId and programType exist only on
 * project rows, so reads of them must be guarded.
 */
export type PayoutTransactionClientData = Clientize<PayoutTransactionsViewWithFincoData>;

export const materialsLabels = [
  { event: PayoutEvent.estimate, name: 'Materials Estimate', order: 1, badgeVariant: 'info' },
  { event: PayoutEvent.invoice, name: 'Materials Invoice', order: 2, badgeVariant: 'primary' },
];
export const flattenedPaymentEventLabelInfo = uniqBy(
  [...Object.values(PayoutEventMap).flat(), ...materialsLabels],
  'event',
);
